import api from 'ApiConfig';

const commonServices = {
  getOwnSalaryDetails: async ({ role, year }) => {
    return api.post(`/${role}/get-salary-details`, { year });
  },
  // In commonServices.js
  getJobNotifications: async (role, params = {}) => {
    const { type, page = 1, limit = 10 } = params;
    return api.post(`/${role}/job-notification`, { type, page, limit });
  },
  // getJobNotifications: async (role) => {
  //   return api.post(`/${role}/job-notification`);
  // },
  markNotificationAsRead: async (role, notificationId) => {
    return api.post(`/${role}/notifications/read`, { notificationId });
  },
  markAllNotificationsAsRead: async (role) => {
    return api.post(`/${role}/notifications/read-all`);
  },
  blockUser: async (userId, role) => {
    return api.post('/admin/block', userId, role);
  },
  unblockUser: async (userId, role) => {
    return api.post('/admin/unblock', userId, role);
  },
  getAllBranches: async () => {
    return api.get('/combinedroutes/get-all-branches');
  },
  getCourseBatchInfo: async (selectedBranch) => {
    return api.post('/combinedroutes/get-batch-course', { selectedBranch });
  },
  getBatchesByCourse: async (courseId, selectedBranch) => {
    return api.post('/combinedroutes/get-course-by-courseId', {
      courseId,
      selectedBranch,
    });
  },
  approveBatch: (payload) => api.post('/superadmin/batch/approve', payload),
  rejectBatch: (payload) => api.post('/superadmin/batch/reject', payload),

  approveBatchUpdate: (payload) =>
    api.post('/superadmin/batch-update/approve', payload),
  rejectBatchUpdate: (payload) =>
    api.post('/superadmin/batch-update/reject', payload),
};

export default commonServices;
